import { Link } from "react-router-dom";
import JsonLd from "@/components/base/JsonLd";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      ...(item.to ? { item: `${origin}${item.to}` } : {}),
    })),
  };

  return (
    <>
      <nav aria-label="面包屑导航">
        <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 font-label text-xs text-foreground-500">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={`${item.label}-${index}`} className="flex items-center gap-2">
                {item.to && !isLast ? (
                  <Link to={item.to} className="transition-colors hover:text-primary-700">
                    {item.label}
                  </Link>
                ) : (
                  <span className={isLast ? "text-foreground-800" : ""}>{item.label}</span>
                )}
                {!isLast ? <i className="ri-arrow-right-s-line" aria-hidden="true" /> : null}
              </li>
            );
          })}
        </ol>
      </nav>
      <JsonLd data={schema} />
    </>
  );
}